import { FieldProps, getIn } from 'formik';
import _ from 'lodash';
import * as React from 'react';
import { MaskField } from 'react-mask-field';
import { BaseInput, IBaseInputProps } from '../../input';

type PhoneFieldProps = IBaseInputProps & {
    field: FieldProps<any>;
    onMaskChange: (value: string) => void;
};

/**
 * Wrapper around PhoneField to be able to work with Form components
 */
export const PhoneField = React.memo<PhoneFieldProps>(props => {
    const {
        field: {
            field: { name, onBlur, value: fieldValue },
            form: { errors, touched: formTouched },
        },
        readOnly,
        onMaskChange,
        capture,
        ...otherProps
    } = props;

    React.useEffect(() => {
        setStateValue(fieldValue);
    }, [fieldValue]);

    const [stateValue, setStateValue] = React.useState(fieldValue);

    const error = getIn(errors, name);
    const touched = getIn(formTouched, name);

    const errorMessage: string | undefined = touched && error ? error : undefined;

    const value = _.isNil(stateValue) ? '' : stateValue; // avoid null or undefined values

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        setStateValue(e.target.value);
    };

    const handleBlur = (e: React.ChangeEvent<any>): void => {
        onBlur(e); // To set 'touched'
        onMaskChange(e.target.value);
    };

    return (
        <MaskField
            mask="+1 (___) ___-____"
            replacement={{ _: /\d/ }}
            readOnly={readOnly}
            disabled={otherProps.disabled}
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            name={name}
            style={{
                width: '100%',
                padding: '8px 12px',
                fontSize: '14px',
                border: errorMessage ? '1px solid #f44336' : '1px solid #ccc',
                borderRadius: '4px',
                outline: 'none',
            }}
            {...otherProps}
        />
    );
});
